import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class DicomService {
  fileSizeUnit: number = 1024;
  public isApiSetup = true;
  private baseURL = `${environment.apiUrl}PatientOrder/`;

  constructor(private _httpClient: HttpClient) {}

  getFileSize(fileSize: number): number {
    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSize = parseFloat((fileSize / this.fileSizeUnit).toFixed(2));
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSize = parseFloat(
          (fileSize / this.fileSizeUnit / this.fileSizeUnit).toFixed(2)
        );
      }
    }

    return fileSize;
  }

  getFileSizeUnit(fileSize: number) {
    let fileSizeInWords = "bytes";

    if (fileSize > 0) {
      if (fileSize < this.fileSizeUnit) {
        fileSizeInWords = "bytes";
      } else if (fileSize < this.fileSizeUnit * this.fileSizeUnit) {
        fileSizeInWords = "KB";
      } else if (
        fileSize <
        this.fileSizeUnit * this.fileSizeUnit * this.fileSizeUnit
      ) {
        fileSizeInWords = "MB";
      }
    }

    return fileSizeInWords;
  }

  uploadDicomfiles(request: FormData) {
    return this._httpClient.post<any>(
      `${this.baseURL}uploadStudyDicom`,
      request,
      {
        responseType: "json",
      }
    );
  }

  uploadPatientHistoryDicomfiles(request: FormData) {
    return this._httpClient.post<any>(
      `${this.baseURL}uploadPatientHistoryStudyDicom`,
      request,
      {
        responseType: "json",
      }
    );
  }
}
